import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import {
  ResourcingLegends,
  resourcingLegendItemsV2
} from '~/modules/resourcing/common/components';
import { useResourceAvailabilityPermissions } from '~/modules/resource-management/ResourcingOverview/hooks';
import { AvailabilityDimensionDropdown } from '~/modules/resource-management/ResourcingOverview/components/ResourceAvailabilityCard/components';
import ProblemFilterDropdown, {
  PROBLEM_FILTER_OPTIONS
} from './ProblemFilterDropdown';
import BenchOverAllocationDetailsViewToggleButton, {
  TOGGLE_VIEW_OPTIONS
} from './BenchOverAllocationDetailsViewToggleButton';

const legends = [
  resourcingLegendItemsV2.bench,
  resourcingLegendItemsV2.boaNotWorking,
  resourcingLegendItemsV2.overAllocation,
  resourcingLegendItemsV2.fittingAllocation,
  resourcingLegendItemsV2.totalResources
];

const getLegends = () => {
  return { none: legends };
};

const useStyles = makeStyles(theme => ({
  root: {
    alignItems: 'center',
    borderTop: `1px solid ${theme.palette.grey[200]}`,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing(1, 2),
    justifyContent: 'space-between',
    padding: theme.spacing(1, 2),
    width: '100%'
  },
  leftSection: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0
  },
  rightSection: {
    display: 'flex',
    alignItems: 'center'
  }
}));

const useLegendsStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(0, 2, 0, 0)
  }
}));

const BenchOverAllocationTrackerToolbar = ({
  groupBy,
  onGroupByChange,
  selectedProblem,
  onProblemFilterChange,
  selectedView,
  onViewChange
}) => {
  const classes = useStyles();
  const legendsClasses = useLegendsStyles();
  const {
    isViewRoleEnabled,
    isViewCostCenterEnabled,
    isViewDivisionEnabled,
    isViewDepartmentEnabled,
    isViewEmployeeTypeEnabled,
    isViewLocationEnabled,
    isViewServiceCenterEnabled
  } = useResourceAvailabilityPermissions();

  return (
    <div className={classes.root}>
      <div className={classes.leftSection}>
        <AvailabilityDimensionDropdown
          value={groupBy}
          onChange={onGroupByChange}
          isViewRoleEnabled={isViewRoleEnabled}
          isViewCostCenterEnabled={isViewCostCenterEnabled}
          isViewDivisionEnabled={isViewDivisionEnabled}
          isViewDepartmentEnabled={isViewDepartmentEnabled}
          isViewEmployeeTypeEnabled={isViewEmployeeTypeEnabled}
          isViewLocationEnabled={isViewLocationEnabled}
          isViewServiceCenterEnabled={isViewServiceCenterEnabled}
        />
        <ProblemFilterDropdown
          value={selectedProblem}
          onChange={onProblemFilterChange}
        />
      </div>
      <div className={classes.rightSection}>
        <ResourcingLegends
          legends={getLegends()}
          showNewLegends
          classes={legendsClasses}
        />
        <BenchOverAllocationDetailsViewToggleButton
          selectedView={selectedView}
          onViewChange={onViewChange}
        />
      </div>
    </div>
  );
};

BenchOverAllocationTrackerToolbar.propTypes = {
  groupBy: PropTypes.string.isRequired,
  onGroupByChange: PropTypes.func.isRequired,
  selectedProblem: PropTypes.oneOf(Object.values(PROBLEM_FILTER_OPTIONS))
    .isRequired,
  onProblemFilterChange: PropTypes.func.isRequired,
  selectedView: PropTypes.oneOf(Object.values(TOGGLE_VIEW_OPTIONS)).isRequired,
  onViewChange: PropTypes.func.isRequired
};

export default BenchOverAllocationTrackerToolbar;
